import React, { useRef, useState } from "react";
import Table from "../table/Table";
import CustomPagination from "../table/CustomPagination";
import { Button, Column } from "devextreme-react/data-grid";
import AdminDialog from "./AdminDialog";
import { CheckBox, NumberBox, SelectBox, TagBox, TextArea} from "devextreme-react";
import { TextBox } from 'devextreme-react/text-box';
import { Button as ActionButton } from 'devextreme-react/button';
import { Icon, IconButton, Typography } from "@material-ui/core";
import { PasswordInput } from "./PasswordInput";
import SearchIcon from '@material-ui/icons/Search';
import { TaxonomySelector } from "./campaigns/TaxonomySelector";

function InputWrapper(props) {
    const { classes, label } = props;
    return (
        <div className="input-admin">
            <label className={classes?.label}>{label}</label>
            <div style={{ width: "75%" }} className="dx-field-value">
                {props.children}
            </div>
        </div>
    )
}

const AdminTable = ({sortField, setsortField, sectionTitle, dataSource, columnasTabla, getData, loading, numElements, onEditingStart, onSaving, onCreate, onEdit, onDelete, masterTitle, customEdition = false, customCreation= false, itemIdField, itemDescriptionField, allowCreate = true, allowEdit = ()=>true, allowDelete = ()=>true, customSearchFields}) => {
    const {pageIndex, pageSize} = dataSource;
    const [searchField, setSearchField] = useState("");
    const [editValues, setEditValues] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [operation, setOperation] = useState(null)
    const [dialogTitle, setDialogTitle] = useState("")
    const openDialog = editValues !== null || selectedItem !== null;
    const tableRef = useRef(null);

    function handlePageSizeChange(value){
        getData({pageIndex: 0, pageSize: value, searchString: searchField.trim(), orderByField: sortField.columna, orderByAscending: sortField.sortOrderAsc})
    }

    const handlePageIndexChange = (event, value) => {
        getData({pageIndex: value -1, pageSize: pageSize, searchString: searchField.trim(), orderByField: sortField.columna, orderByAscending: sortField.sortOrderAsc})
    };

    function handleSearch(){
        getData({pageSize: pageSize, pageIndex: 0, searchString: searchField.trim(), orderByField: sortField.columna, orderByAscending: sortField.sortOrderAsc})
    }

    function handleRefresh(){
        getData({pageIndex: pageIndex, pageSize: pageSize, searchString: searchField.trim(), orderByField: sortField.columna, orderByAscending: sortField.sortOrderAsc})
    }

    function handleStartEditing({row}){
        const entityValues = row.cells.map(cell=>
        {
         if(cell.column.type !== "buttons" && cell.column.allowEditing){
                const editData = {
                                key: cell.column.dataField,
                                value: cell.column.lookup? Array.isArray(cell.value) ? cell.value.map(v=> v[cell.column.lookup.valueExpr] || v) : cell.value : cell.column.dataType === "string" && !cell.value ? "" : cell.value,
                                dataType: cell.column.lookup? "lookup" : cell.column.dataType,
                                label: cell.column.caption,
                                options: cell.column.lookup
                            }
                return editData
         }
        }
        ).filter(row=> row !== undefined);

        const entityId = {
            [itemIdField]: row.key[itemIdField],
            [itemDescriptionField]: row.key[itemDescriptionField]
        }
    
        setSelectedItem(entityId)
        setEditValues(entityValues)
        setOperation("edit")
        setDialogTitle(`Editar ${masterTitle}`)
    }

    function handleEditField(field, newValue){
        const updatedValues = editValues.map((originalValue)=> originalValue.key === field? {...originalValue, value: newValue.value} : originalValue )
        setEditValues(updatedValues)

    }


    function handleEditMultipleChoiceField(field, newValue){
            const updatedValues = editValues.map((originalValue)=> originalValue.key === field? {...originalValue, value: (newValue.length > 0 ? newValue : [])} : originalValue )
            setEditValues(updatedValues)
    }


    function handleTaxonomyChange(field, newTaxonomyValue) {
        const newValue = {
            level_1: newTaxonomyValue.taxonomyLevel_1,
            level_2: newTaxonomyValue.taxonomyLevel_2,
            level_3: newTaxonomyValue.taxonomyLevel_3,
            level_4: newTaxonomyValue.taxonomyLevel_4}

        const updatedValues = editValues.map((originalValue)=> originalValue.key === field? {...originalValue, value: newValue} : originalValue )
        setEditValues(updatedValues)
    }


    function handleOnSubmit(){
        if(operation === "create"){
            const createObject = editValues.reduce((object, editValue) => {   object[editValue.key] = editValue.value;  return object; }, {})
            onCreate(createObject, closeModal)
        }
        if(operation === "edit"){
            const editObject = editValues.reduce((object, editValue) => {   object[editValue.key] = editValue.value;  return object; }, {})
            onEdit({...editObject, [itemIdField] : selectedItem[itemIdField] }, closeModal)
        }
        if(operation === "delete"){
            const {[itemIdField] : deleteId} = selectedItem
            onDelete(deleteId, closeModal)
        }
    }

    function handleStartDeleting({row}){
        setOperation("delete")
        const entityValues = {
            [itemIdField]: row.key[itemIdField],
            [itemDescriptionField]: row.key[itemDescriptionField]
        }
    
        setSelectedItem(entityValues)
        setDialogTitle(`Excluir ${masterTitle}`)
    }


    const columnsEdition = [
    <Column key={"acciones"} width={100} type={"buttons"}>
                <Button visible={({row})=>allowEdit(row)} onClick={handleStartEditing} hint={"Editar"} icon="edit" style={{ marginRight: '10px' }} />
                {onDelete !== undefined && <Button visible={({row})=>allowDelete(row)} onClick={handleStartDeleting} hint={"Eliminar"} icon="trash" /> }
    </Column>
    ]

    function renderEditValues(){
        if(editValues !== null){
            return(
                editValues.map(editValue=>
                    <InputWrapper key={editValue.key} label={editValue.label}>
                        {
                            editValue.dataType === "string" && 
                                <TextBox height={35} value={editValue.value} onValueChanged={(e)=>{handleEditField(editValue.key, e)}}/>
                        }
                        {
                            editValue.dataType === "textarea" && 
                                <TextArea height={120} value={editValue.value} onValueChanged={(e)=>{handleEditField(editValue.key, e)}}/>
                        }
                        {
                            editValue.dataType === "password" && 
                            <PasswordInput value={editValue.value} setValue={(value)=>{handleEditField(editValue.key, value)}}/>

                        }
                        {
                            editValue.dataType === "number" && 
                                <NumberBox  height={35} value={editValue.value} onValueChanged={(e)=>{handleEditField(editValue.key, e)}}/>
                        }
                        {
                            editValue.dataType === "boolean" &&
                                <CheckBox value={editValue.value} onValueChanged={(e)=>{handleEditField(editValue.key, e)}}/>
                        }
                        {
                            editValue.dataType === "lookup" && !editValue.options.multiple &&
                            <SelectBox
                            dataSource = { editValue.options.dataSource }
                            showClearButton = { false }
                            value = {editValue.value}
                            displayExpr = { editValue.options.displayExpr }
                            valueExpr = { editValue.options.valueExpr }
                            onValueChanged = {(e)=>{handleEditField(editValue.key, e)}}
                            searchEnabled = { true }
                            />
                        }
                        {
                            editValue.dataType === "lookup" && editValue.options.multiple &&
                            <TagBox
                            dataSource = { editValue.options.dataSource }
                            showClearButton = { false}
                            defaultValue = {editValue.value || null}
                            displayExpr = { editValue.options.displayExpr }
                            valueExpr = { editValue.options.valueExpr }
                            onValueChanged =  {(e)=>{handleEditMultipleChoiceField(editValue.key, e.value,)}}
                            searchEnabled = { true }
                            hideSelectedItems
                            />
                        }
                        {
                            editValue.dataType === "taxonomy" &&
                            <TaxonomySelector selectedTaxonomy={editValue.value} index={0} handleTaxonomiesChange={(newValue)=>handleTaxonomyChange(editValue.key, newValue)}/>         
                             }
                    </InputWrapper>
                )
            )
        }
            
    } 

    function handleCreateNew(){
        setOperation("create")
        const visibleColumns = tableRef.current.instance.getVisibleColumns();
        const createFields = visibleColumns.map(column=>
        {
            if(column.type !== "buttons" && (column.allowEditing || column.allowCreating)){
                   const editData = {
                                   key: column.dataField,
                                   dataType: column.lookup? "lookup" : column.dataType,
                                   label: column.caption,
                                   options: column.lookup,
                                   value: column.dataType === "string" ? "" : column.dataType === "boolean" ? false : undefined
                               }
                   return editData
            }
        }
        ).filter(field=> field !== undefined)
        setEditValues(createFields)
        setDialogTitle(`Adicionar ${masterTitle}`)
    }

    function renderDeleteMessage(){
        if(selectedItem){
            return(
            <Typography>
            {`Será removido o ${masterTitle} "${selectedItem[itemDescriptionField]}".`}
            </Typography>
            )
        }

    }

    function closeModal(){
        setEditValues(null);
        setSelectedItem(null);
    }

    function handleCellClick (e) {
        if (e.rowType == "header" && (e.column.type !== "selection" && e.column.type !== "buttons")) {
            let columna = e.column.dataField;
            let sortOrder = e.column.sortOrder;
            if (sortOrder == undefined || sortOrder == "undefined") {
                e.column.sortOrder = 'asc';
            }
            else if (sortOrder == 'desc') {
                e.column.sortOrder = 'asc';
            }
    
            else if (sortOrder == 'asc') {
                e.column.sortOrder = 'desc';
            }
            let orden = e.column.sortOrder == 'asc' ? true : false;
            setsortField({columna, sortOrderAsc: orden})
            getData({pageIndex: pageIndex, pageSize: pageSize, searchString: searchField.trim(), orderByField: columna, orderByAscending: orden})
        }   
    }


    return (
        <>
            <div style={{margin: "auto", width: "90%"}}>
            <span style={{display:"flex", justifyContent: "center"}}><Typography>{sectionTitle}</Typography></span>
            <div style={{ display:"flex", justifyContent: "space-between", alignItems: "center"}}>
            <div style={{margin: "10px", display: "flex", alignItems: "center", justifyContent: "flex-start"}}>
                <TextBox
                    placeholder="Procurar"
                    value={searchField}
                    mode="text"
                    onValueChange={(value)=>setSearchField(value)}
                    onEnterKey={()=>handleSearch()}
                    >     
                </TextBox>
                <div>
                    {customSearchFields}
                </div>
                <IconButton onClick={()=>handleSearch()} size="small" title="Buscar"><SearchIcon htmlColor="#3B5158"/></IconButton>
            </div>
            <div style={{margin: "10px"}}>
                <ActionButton
                    onClick={customCreation? onCreate : handleCreateNew}
                    disabled={!allowCreate}
                    icon="plus"
                    text="Adicionar"
                />
            </div>
            </div>
            </div>
            <div style={{width: "90%", margin: "auto", padding: 0}}>
                    <Table handleCellClick={handleCellClick} reference={tableRef} loading={loading} datasource={dataSource.elements} columnasTabla={customEdition ? columnasTabla: [...columnasTabla, ...columnsEdition]} editing={false} onEditingStart={onEditingStart} onSaving={onSaving} />
                    <CustomPagination refreshPage={handleRefresh} style={{position: "absolute"}} numElements={numElements} loading={loading} count={dataSource.totalRecords} pageSize={pageSize} pageIndex={pageIndex + 1} totalPages={dataSource.totalPages} handlePageSizeChange={handlePageSizeChange} handlePageIndexChange={handlePageIndexChange} />
            </div>
            <AdminDialog title={dialogTitle} operation={operation} dialogSize={{height: "100%"}} open={openDialog} onClose={closeModal} handleOnClick={handleOnSubmit}>
                {operation === "delete" ? renderDeleteMessage() : renderEditValues()}
            </AdminDialog>
        </>
    )
}

export { AdminTable }